//todo: send message to speed core to display in game like "player disconnected", could be used for computer to as a taunt
import PlayerComputer from "./PlayerComputer.js"
export default class PlayerSocketIO_Simple {

    constructor(socket, game, name, localPlayer, room, useBackupComputer) {
        //public = this.
        this.game = game;
        this.name = name;
        this.isLocal = false;
        this.localPlayer = localPlayer;
        this.room = room;
        this.useBackupComputer = useBackupComputer;
        this.readyEvent = function () { };
        this.isDestroyed = false;


        this.socket = socket;
        this.socket.onMessage = this.onMessage.bind(this);
        this.socket.onGameStart =  this.onGameStart.bind(this);
        this.socket.onGetRoom = this.onGetRoom.bind(this);
        this.socket.onUserDisconnected = this.onUserDisconnected.bind(this);
        this.socket.onJoined = this.onJoined.bind(this);
        this.socket.onRoomChanged =this.onRoomChanged.bind(this);
        this.socket.onPong = this.onPong.bind(this);


        //join room
        if (room)
            this.socket.joinRoom(room);
    }

    onMessage  (data) {

    // var msgArray = data.split("|");
    if (data.message == 'cardMoved') {
        this.game.addToPile(this.game.getCard(data.value), data.location, "network");
    }
    //network predict animation
    if (data.message == 'startDrag') {
        //todo: find pile it can play on, if any
        var tryDropPile = "hs1";
        var canDropHs2 = this.game.canDrop(this.game.getCard(data.value), "hs2");
        if (canDropHs2) tryDropPile = "hs2";
        this.game.moveCardToPile(this.game.getCard(data.value), tryDropPile, 800, "network");
    }
    //network predict animation stop
    if (data.message == 'stopDrag') {
        this.game.stopMoveCardToPile(this.game.getCard(data.value), null, null, "network");
    }
    if (data.message == 'setUpGame') {
        if (data.value) {
            this.game.start(data.value);
        }
    }
};
onPong  (ms) {
    console.log("Pong: " + ms);
    this.socket.logPing(ms);
};
onGameStart  (data) {

    //todo:remove and just get an int from server
    //or use new matchid from server
    this.game.matchId = this.hashCode(data.name);

    //if player 1 then deal the deck
    if (this.game.PlayerBottom === this.localPlayer) {
        this.game.start();
    }
};

hashCode  (str) {
    let hash = 0;
    if (str.length == 0) return hash;
    for (let i = 0; i < str.length; i++) {
        let char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}
onJoined  (data) {
    this.socket.getRoom(data);
};
onRoomChanged (data) {
    this.socket.getRoom(data);
};

onGetRoom  (data) {

    if (this.game.state != "Playing" || !this.useBackupComputer) {

        this.name = 'Searching...';
        this.rank = '';
        this.avatar = 'images/Avatars/default-avatar.png';
        //todo: there should be a better way to know who is the remote player
        if (data.users[0] && this.localPlayer.name !== data.users[0].name) {
            this.id = data.users[0].id;
            this.name = data.users[0].name;
            this.avatar = data.users[0].avatar;
            this.rank = data.users[0].rank;
        }
        if (data.users[1] && this.localPlayer.name !== data.users[1].name) {
            this.id = data.users[1].id;
            this.name = data.users[1].name;
            this.avatar = data.users[1].avatar;
            this.rank = data.users[1].rank;
        }
        //set player in slots
        if (data.users[0] && this.name === data.users[0].name) {
            this.game.PlayerBottom = this; //player1
            this.game.PlayerTop = this.localPlayer; //player2
        } else {
            this.game.PlayerBottom = this.localPlayer; //player1
            this.game.PlayerTop = this; //player2
        }
    }
    if (this.game.state == "Playing" && this.useBackupComputer) {
        //if you are the only one left, switch the online player to a computer
        if (data.users.length == 1 && data.users[0].name == this.localPlayer.name)
            this.switchToComputer();
    }
    this.game.message("playerChanged");

};
onUserDisconnected  (data) {
    this.game.message("userDisconnected");
};



sendMessage  (data) {
    this.socket.sendMessage(data);
};
sendLogin  (data) {
    this.socket.login(data);
};
joinRoom (data) {
    this.socket.joinRoom(data);
};
getUsers (data) {
    this.socket.getUsers(data);
};
 getRooms  (data) {
    this.socket.getRoom(data);
};
 getRoom  (data) {
    this.socket.getRoom(data);
};
gameStart  () {
    this.socket.gameStart();
};

destroy  () {
  let isDestroyed = this.isDestroyed;
    if (!isDestroyed) {
        //destroy 
        isDestroyed = true;

        console.log("socket.destroy");

        this.socket.onMessage = null;
        this.socket.onGameStart = null;
        this.socket.onGetRoom = null;
        this.socket.onUserDisconnected = null;
        this.socket.onJoined = null;
        this.socket.onRoomChanged = null;

        // //had an issue of destroying right be fore creating and the joing room was messing things up.  So destory only once.
        // this.socket.joinRoom('lost');

        this.socket.destroy();
    }
};
switchToComputer  () {
    //which player disconnected?

    //turn on a computer for the player that left
    var playerComputer = new PlayerComputer(this.game, "Hard", "Hard");// player --> game com
    playerComputer.startComputer();
    this.game.showSelection = false; //todo: should be set in computer player
    playerComputer.id = this.id;
    playerComputer.name = this.name;
    playerComputer.avatar = this.avatar;
    playerComputer.rank = this.rank;

    if (this.game.PlayerTop === this) this.game.PlayerTop = playerComputer;
    if (this.game.PlayerBottom === this) this.game.PlayerBottom = playerComputer;


    this.destroy();

};

//todo: the model could send en event and this class listen to it, or it get called directly from the model as done below
gameEvent  (message, value, location, player) {
    //if (message == "start") this.startComputer();
    //if (message == "pause") this.pause();
    //if (message == "resume") this.resume();
    if (message == "dispose") this.dispose();
    if (message == "destroy") this.destroy();
    //if (message == "gameover") this.gameover();
    //if (message == "pull") {
    //    _pullWaitCounter = 2; //wait 2 cycles
    //}
    if (player !== "network") {

        if (message === "cardMoved" || message === "startDrag" || message === "stopDrag" || message === "setUpGame")
            this.sendMessage({ message: message, value: value, location: location, player: player });
    }

};
logMessage  (event, data) {
    if (Config && Config.DebugMode) console.log(event + " " + data);
}
}